import request from '../utils/request';
import { userAuthorUrl, activityUrl } from './apiConfig';
// 获取验证码
export function getVerifycode(data) {
  return request(`${userAuthorUrl}/getVerifycode`, data);
}

// 登录
// export function reg(data) {
//   return request(`${userAuthorUrl}/reg`, data);
// }
export function reg(data) {
    return request(`${activityUrl}/prizeGrant/activity/${window._activityKey}/login`, data, { withoutLogin: true});
}

// 推广用户登录记录渠道
export const regWithChannel = (data) => request(`${userAuthorUrl}/recommendReg`, data)

// 获取礼包
export function getCoupon() {
  return request(`${activityUrl}/activity/getCoupon`, {activityKey: window._activityKey});
}

// 分享获礼包
export function getShareCoupon() {
  return request(`${activityUrl}/prizeGrant/activity/getShareCoupon`, {activityKey: window._activityKey});
}

// 已登录获礼包
export function loggedCoupon(data) {
  return request(`${activityUrl}/prizeGrant/activity/${window._activityKey}/logged`, data);
}